import axios from './axios';
import { heartBeatLogout } from '../actions/auth';
import { HEART_BEAT_SCRIPT_URL } from '../config';

let intervalId = '';

export async function startHeartBeat(dispatch) {
    const idpPingCall = async () => {
        try {
            await axios.get(HEART_BEAT_SCRIPT_URL, {
                withCredentials: true
            });
        } catch (e) {
            if (e.response && e.response.status === 401) {
                dispatch(heartBeatLogout());
                clearInterval(intervalId);
            }
        }
    };

    intervalId = setInterval(idpPingCall, 60000);
}

export async function stopHeartBeat() {
    clearInterval(intervalId);
}

export function handleUnauthorizedError(error, dispatch) {
    if (error.response && error.response.status === 401) {
        dispatch(heartBeatLogout());
        stopHeartBeat();
    }
}
